import React from 'react';
import config from '../config';
import { HeaderContext } from './Context';
export default function GetHeaderStyles() {
  return /*#__PURE__*/React.createElement(HeaderContext.Consumer, null, function (value) {
    if (!value) {
      console.error(JSON.stringify({
        type: 'haas-error',
        msg: config.ERR_MISSING_STYLES
      }));
      return null;
    }

    return value.styles ? /*#__PURE__*/React.createElement("link", {
      rel: "stylesheet",
      href: value.styles
    }) : null;
  });
}